/* LP Collab: carrossel com scroll-snap, setas e indicadores */
if (!customElements.get('lp-collab-carousel')) {
  class LpCollabCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.nav = this.querySelector('[data-carousel-nav]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.dots = this.querySelector('[data-carousel-dots]');
      this.counter = this.querySelector('[data-carousel-counter]');
      if (!this.track) return;

      this.pageCount = 0;
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.prev?.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
      this.next?.addEventListener('click', () => this.goTo(this.currentIndex() + 1));

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    step() {
      const slides = this.track.children;
      if (slides.length < 2) return this.track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    maxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    currentIndex() {
      const max = this.maxScroll();
      if (this.track.scrollLeft >= max - 1) return this.pageCount - 1;
      return Math.round(this.track.scrollLeft / this.step());
    }

    goTo(index) {
      const target = Math.min(Math.max(index, 0), this.pageCount - 1);
      this.track.scrollTo({ left: Math.min(target * this.step(), this.maxScroll()), behavior: 'smooth' });
    }

    renderDots(count) {
      if (!this.dots) return;
      this.dots.replaceChildren(
        ...Array.from({ length: count }, (_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'lp-collab-carousel__dot';
          dot.setAttribute('aria-label', `Ir para o item ${index + 1}`);
          dot.addEventListener('click', () => this.goTo(index));
          return dot;
        })
      );
    }

    update() {
      const max = this.maxScroll();
      const count = max > 1 ? Math.ceil(max / this.step() - 0.01) + 1 : 1;

      if (count !== this.pageCount) {
        this.pageCount = count;
        this.renderDots(count);
      }

      if (this.nav) this.nav.hidden = count < 2;

      const current = this.currentIndex();
      this.dots?.querySelectorAll('button').forEach((dot, index) => {
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
      if (this.counter) this.counter.textContent = `${current + 1}/${count}`;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  customElements.define('lp-collab-carousel', LpCollabCarousel);
}
